import { all, fork } from 'redux-saga/effects'

import NavigationSaga from './NavigationSaga'

export default function* navigationSagas() {
  yield all([fork(new NavigationSaga().supervise)])
}
